module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-page"
  }, [_c('div', {
    staticClass: "container notification-page__container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-push-2"
  }, [_c('div', {
    staticClass: "card ui-card form--account notification-card"
  }, [_c('div', {
    staticClass: "content content-pad-top"
  }, [_c('h1', {
    staticClass: "notification-title"
  }, [_vm._v(_vm._s(_vm.titlePage))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "text-reader notification-upload-label"
  }, [_vm._v("\n                " + _vm._s(_vm.locale.t('label_load_image')) + " ( "), _c('b', [_vm._v("max 5MB")]), _vm._v(") "), _c('i', {
    staticClass: "ti-upload"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.loadTextFromFile
    }
  })]), _vm._v(" "), (_vm.selectedImagePreview != null) ? _c('div', {
    staticClass: "ci-training-main notification-preview"
  }, [_c('div', {
    staticClass: "ci-training-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "ci-training",
    style: ('background-image: url(' + _vm.selectedImagePreview + ');')
  }, [_c('div', {
    staticClass: "c2 discount-margin"
  })])]) : _vm._e(), _vm._v(" "), (_vm.selectedImagePreview == null && _vm.imageUrl != null) ? _c('div', {
    staticClass: "ci-training-main notification-preview"
  }, [_c('div', {
    staticClass: "ci-training-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "ci-training",
    style: ('background-image: url(' + _vm.imageUrl + ');')
  }, [_c('div', {
    staticClass: "c2 discount-margin"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_ci_position')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNumber),
      expression: "orderNumber"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": _vm.locale.t('label_ci_position'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.orderNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_c('i', {
    staticClass: "form-hint-text"
  }, [_vm._v("*" + _vm._s(_vm.locale.t('label_ci_position_desc')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_notification_priority')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.priority),
      expression: "priority"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.priority = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "LOW",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_notification_low')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MEDIUM"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_notification_medium')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HIGH"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_notification_high')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "notification-checkbox-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendNotification),
      expression: "sendNotification"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sendNotification) ? _vm._i(_vm.sendNotification, null) > -1 : (_vm.sendNotification)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sendNotification,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sendNotification = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sendNotification = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sendNotification = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_send_notification')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card ui-card form--account notification-card"
  }, [_c('div', {
    staticClass: "content content-pad-top"
  }, [_c('p', {
    staticClass: "report-toggle-label notification-toggle",
    on: {
      "click": function($event) {
        _vm.showPersonalMessage = !_vm.showPersonalMessage
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.locale.t('label_show_personal_message')) + "\n              "), _c('i', {
    class: _vm.showPersonalMessage ? 'ti-arrow-circle-up' : 'ti-arrow-circle-down'
  })]), _vm._v(" "), (_vm.showPersonalMessage) ? _c('div', {
    staticClass: "section-top-xs"
  }, [_c('div', {
    staticClass: "notification-hint"
  }, [_c('i', [_vm._v("*" + _vm._s(_vm.locale.t('label_show_personal_message_desc')))])]), _vm._v(" "), _c('div', {
    staticClass: "scrollmenuStart section-top-xs notification-chip-scroll"
  }, _vm._l((_vm.trainingTypes), function(item) {
    return _c('span', {
      key: item
    }, [_c('span', {
      staticClass: "chips-group clickable",
      on: {
        "click": function($event) {
          return _vm.clickTrainingTypes(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClass(item)
    }, [_vm._v(_vm._s(_vm.isSelected(item) ? '✔ ' : '') + _vm._s(item))])])])])
  }), 0)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card ui-card form--account notification-card"
  }, [_c('div', {
    staticClass: "content content-pad-top"
  }, [_c('div', {
    staticClass: "notification-bilingual-grid"
  }, [_c('div', {
    staticClass: "notification-field"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("*" + _vm._s(_vm.locale.t('label_input_title_serbian')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control input",
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "notification-field"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_input_title_english')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enTitle),
      expression: "enTitle"
    }],
    staticClass: "form-control input",
    domProps: {
      "value": (_vm.enTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.enTitle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "notification-field"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("*" + _vm._s(_vm.locale.t('label_input_serbian')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "form-control input notification-textarea",
    attrs: {
      "rows": "8"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "notification-field"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_input_english')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enText),
      expression: "enText"
    }],
    staticClass: "form-control input notification-textarea",
    attrs: {
      "rows": "8"
    },
    domProps: {
      "value": (_vm.enText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.enText = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "card ui-card form--account notification-card notification-card--footer"
  }, [_c('div', {
    staticClass: "content content-pad-top"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_link')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.link),
      expression: "link"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "email",
      "placeholder": _vm.locale.t('label_link'),
      "name": "email"
    },
    domProps: {
      "value": (_vm.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.link = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center notification-save-wrap"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_save')))])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-arrow-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-arrow-circle-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-link"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-052e3024!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notification/Notification.vue
// module id = 697
// module chunks = 0